import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Activity, RefreshCw, Moon } from 'lucide-react';
export function AuthoritySection() {
  const badges = [{
    icon: <Brain size={32} data-id="element-24" />,
    text: 'Neurociencia Aplicada'
  }, {
    icon: <Activity size={32} data-id="element-25" />,
    text: 'Regulación Somática'
  }, {
    icon: <RefreshCw size={32} data-id="element-26" />,
    text: 'Neuroplasticidad'
  }, {
    icon: <Moon size={32} data-id="element-27" />,
    text: 'Hábitos Restaurativos'
  }];
  return <section className="py-20 px-4 bg-white border-y border-sage/20" data-id="element-28">
      <div className="max-w-4xl mx-auto text-center" data-id="element-29">
        <img src="https://cdn.magicpatterns.com/uploads/u4vVWFEjLHUUaDyHjbos5K/ChatGPT_Image_2_may_2026,_09_46_27_p.m._-_copia.png" alt="En 30 días puedes dormir profundamente, reducir la ansiedad, sentir ligereza emocional - basado en neurociencia aplicada" className="w-full max-w-2xl mx-auto rounded-2xl shadow-lg mb-12" data-id="element-30" />
        <h2 className="font-display font-bold text-2xl sm:text-3xl md:text-4xl text-teal mb-10 md:mb-12 break-words" data-id="element-31">
          Fundamentado en ciencia real.
        </h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-12" data-id="element-32">
          {badges.map((badge, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex flex-col items-center text-center" data-id="element-33">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-beige flex items-center justify-center text-teal mb-3 sm:mb-4 shadow-sm border border-sage/30" data-id="element-34">
                {badge.icon}
              </div>
              <span className="text-xs sm:text-sm font-heading font-bold text-teal leading-tight break-words px-1" data-id="element-35">
                {badge.text}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-neutral-gray font-sans text-lg max-w-3xl mx-auto leading-relaxed italic" data-id="element-36">
          "Este sistema integra los avances más recientes en regulación del
          sistema nervioso autónomo, respaldados por décadas de investigación en
          neurociencia del estrés y medicina integrativa."
        </motion.p>
      </div>
    </section>;
}